// export const imageCompressionOptions = {  // https://github.com/Donaldcwl/browser-image-compression
//     maxSizeMB: 5
// }
export const REACT_APP_WALLET_CONNECT_PROJECT_ID = "2584a9770d21c205a868e97417e16b13";
